// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   DIAMOND MAP MODAL — bespoke map-viewport modal
   for diamond teaching nodes. Intentionally minimal:
   backdrop + panel + close X only. DiamondSession's
   own chrome (header/step indicator/content/bottom bar)
   does the work inside.
   ============================================ */

.dmm-viewport {
  position: absolute;
  inset: 0;
  z-index: 100;
  container-type: inline-size;
}

body > .dmm-viewport {
  position: fixed;
}

.dmm-overlay {
  position: absolute;
  inset: 0;
  z-index: 100;
  background: rgba(6, 4, 8, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  padding: 28px;
  animation: dmm-scrim-fade-in 0.16s ease-out;
}

@keyframes dmm-scrim-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

.dmm-body {
  --dmm-close-reserve: 56px;
  --dmm-content-pad-x: 18px;
  --dmm-header-pad-top: 14px;
  --dmm-header-pad-bottom: 10px;
  --dmm-bottom-pad-y: 12px;
  --dmm-loading-pad: 24px;
  position: relative;
  width: 100%;
  height: 100%;
  background: rgba(10, 10, 14, 0.96);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border: 1px solid rgba(168, 85, 247, 0.14);
  border-radius: 10px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.55),
    0 0 0 1px rgba(168, 85, 247, 0.04) inset;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: dmm-pop-in 0.22s cubic-bezier(0.34, 1.2, 0.5, 1);
}

@keyframes dmm-pop-in {
  from { opacity: 0; transform: scale(0.98); }
  to   { opacity: 1; transform: scale(1); }
}

.dmm-close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 5;
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(168, 85, 247, 0.08);
  border: 1px solid rgba(168, 85, 247, 0.22);
  border-radius: 8px;
  color: rgba(192, 132, 252, 0.85);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.dmm-close:hover {
  background: rgba(168, 85, 247, 0.18);
  border-color: rgba(168, 85, 247, 0.45);
  color: #fff;
}

.dmm-content {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ── LevelSession embedded inside the diamond modal.
   Same idea as \`.mcp-embedded-session\` overrides: collapse the full-page
   wrappers so DiamondSession inside them fits the modal body. ── */

.dmm-content .ls-page,
.dmm-content .ls-card-mode {
  min-height: 0;
  height: 100%;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: transparent;
  overflow: hidden;
}

.dmm-content .ls-header,
.dmm-content .ls-trial-warning {
  display: none;
}

.dmm-content .ls-loading,
.dmm-content .ls-generating {
  min-height: 0;
  flex: 1 1;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--dmm-loading-pad);
  gap: var(--space-3);
}

/* DiamondSession — full-page variant sets min-height: 100vh + bg-base. In
   the modal we let the modal body own the backdrop and DiamondSession owns
   the interior flex. Keep diamond-header/content-scroll/bottom-bar visible
   — they're the point of this modal. */
.dmm-content .diamond-session {
  min-height: 0;
  height: 100%;
  max-width: none;
  margin: 0;
  background: transparent;
  flex: 1 1;
}

.dmm-content .diamond-empty {
  min-height: 0;
  flex: 1 1;
}

/* Hide DiamondSession's own back button — the modal's close X owns exit. */
.dmm-content .diamond-back-btn {
  display: none;
}

.dmm-content .diamond-header {
  padding: var(--dmm-header-pad-top) var(--dmm-close-reserve) var(--dmm-header-pad-bottom) var(--dmm-content-pad-x); /* clear close button */
}

.dmm-content .diamond-bottom-bar {
  flex-shrink: 0;
  background: rgba(10, 10, 14, 0.96);
  border-top: 1px solid rgba(168, 85, 247, 0.08);
  padding: var(--dmm-bottom-pad-y) var(--dmm-content-pad-x);
}

/* Fallback when portal target isn't a map viewport: become centered overlay. */
body > .dmm-overlay {
  position: fixed;
  padding: 40px;
}

@container (max-width: 1800px) {
  .dmm-overlay {
    padding: clamp(18px, 1.55cqi, 28px);
  }

  .dmm-body {
    --dmm-close-reserve: clamp(48px, 3.2cqi, 56px);
    --dmm-content-pad-x: clamp(14px, 1.05cqi, 18px);
    --dmm-header-pad-top: clamp(10px, 0.82cqi, 14px);
    --dmm-header-pad-bottom: clamp(8px, 0.62cqi, 10px);
    --dmm-bottom-pad-y: clamp(10px, 0.75cqi, 12px);
    --dmm-loading-pad: clamp(18px, 1.35cqi, 24px);
  }
}

@container (max-width: 640px) {
  .dmm-overlay { padding: 16px; }
}

body > .dmm-viewport .dmm-overlay {
  padding: 40px;
}

@media (max-width: 640px) {
  body > .dmm-overlay,
  body > .dmm-viewport .dmm-overlay {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DiamondMapModal/DiamondMapModal.css"],"names":[],"mappings":"AAAA;;;;;;iDAMiD;;AAEjD;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;EACb,oBAAoB;EACpB,wBAAwB;EACxB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB;;4CAE0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2DAA2D;AAC7D;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;mEAEmE;;AAEnE;;EAEE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,SAAO;EACP,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;;uCAGuC;AACvC;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA,2EAA2E;AAC3E;EACE,aAAa;AACf;;AAEA;EACE,iHAAiH,EAAE,uBAAuB;AAC5I;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,8CAA8C;EAC9C,yDAAyD;AAC3D;;AAEA,+EAA+E;AAC/E;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,8CAA8C;IAC9C,+CAA+C;IAC/C,gDAAgD;IAChD,kDAAkD;IAClD,8CAA8C;IAC9C,6CAA6C;EAC/C;AACF;;AAEA;EACE,eAAe,aAAa,EAAE;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;IAEE,aAAa;EACf;AACF","sourcesContent":["/* ============================================\n   DIAMOND MAP MODAL — bespoke map-viewport modal\n   for diamond teaching nodes. Intentionally minimal:\n   backdrop + panel + close X only. DiamondSession's\n   own chrome (header/step indicator/content/bottom bar)\n   does the work inside.\n   ============================================ */\n\n.dmm-viewport {\n  position: absolute;\n  inset: 0;\n  z-index: 100;\n  container-type: inline-size;\n}\n\nbody > .dmm-viewport {\n  position: fixed;\n}\n\n.dmm-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 100;\n  background: rgba(6, 4, 8, 0.55);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  padding: 28px;\n  animation: dmm-scrim-fade-in 0.16s ease-out;\n}\n\n@keyframes dmm-scrim-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.dmm-body {\n  --dmm-close-reserve: 56px;\n  --dmm-content-pad-x: 18px;\n  --dmm-header-pad-top: 14px;\n  --dmm-header-pad-bottom: 10px;\n  --dmm-bottom-pad-y: 12px;\n  --dmm-loading-pad: 24px;\n  position: relative;\n  width: 100%;\n  height: 100%;\n  background: rgba(10, 10, 14, 0.96);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  border: 1px solid rgba(168, 85, 247, 0.14);\n  border-radius: 10px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.55),\n    0 0 0 1px rgba(168, 85, 247, 0.04) inset;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: dmm-pop-in 0.22s cubic-bezier(0.34, 1.2, 0.5, 1);\n}\n\n@keyframes dmm-pop-in {\n  from { opacity: 0; transform: scale(0.98); }\n  to   { opacity: 1; transform: scale(1); }\n}\n\n.dmm-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 5;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(168, 85, 247, 0.08);\n  border: 1px solid rgba(168, 85, 247, 0.22);\n  border-radius: 8px;\n  color: rgba(192, 132, 252, 0.85);\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.dmm-close:hover {\n  background: rgba(168, 85, 247, 0.18);\n  border-color: rgba(168, 85, 247, 0.45);\n  color: #fff;\n}\n\n.dmm-content {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* ── LevelSession embedded inside the diamond modal.\n   Same idea as `.mcp-embedded-session` overrides: collapse the full-page\n   wrappers so DiamondSession inside them fits the modal body. ── */\n\n.dmm-content .ls-page,\n.dmm-content .ls-card-mode {\n  min-height: 0;\n  height: 100%;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: transparent;\n  overflow: hidden;\n}\n\n.dmm-content .ls-header,\n.dmm-content .ls-trial-warning {\n  display: none;\n}\n\n.dmm-content .ls-loading,\n.dmm-content .ls-generating {\n  min-height: 0;\n  flex: 1;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--dmm-loading-pad);\n  gap: var(--space-3);\n}\n\n/* DiamondSession — full-page variant sets min-height: 100vh + bg-base. In\n   the modal we let the modal body own the backdrop and DiamondSession owns\n   the interior flex. Keep diamond-header/content-scroll/bottom-bar visible\n   — they're the point of this modal. */\n.dmm-content .diamond-session {\n  min-height: 0;\n  height: 100%;\n  max-width: none;\n  margin: 0;\n  background: transparent;\n  flex: 1;\n}\n\n.dmm-content .diamond-empty {\n  min-height: 0;\n  flex: 1;\n}\n\n/* Hide DiamondSession's own back button — the modal's close X owns exit. */\n.dmm-content .diamond-back-btn {\n  display: none;\n}\n\n.dmm-content .diamond-header {\n  padding: var(--dmm-header-pad-top) var(--dmm-close-reserve) var(--dmm-header-pad-bottom) var(--dmm-content-pad-x); /* clear close button */\n}\n\n.dmm-content .diamond-bottom-bar {\n  flex-shrink: 0;\n  background: rgba(10, 10, 14, 0.96);\n  border-top: 1px solid rgba(168, 85, 247, 0.08);\n  padding: var(--dmm-bottom-pad-y) var(--dmm-content-pad-x);\n}\n\n/* Fallback when portal target isn't a map viewport: become centered overlay. */\nbody > .dmm-overlay {\n  position: fixed;\n  padding: 40px;\n}\n\n@container (max-width: 1800px) {\n  .dmm-overlay {\n    padding: clamp(18px, 1.55cqi, 28px);\n  }\n\n  .dmm-body {\n    --dmm-close-reserve: clamp(48px, 3.2cqi, 56px);\n    --dmm-content-pad-x: clamp(14px, 1.05cqi, 18px);\n    --dmm-header-pad-top: clamp(10px, 0.82cqi, 14px);\n    --dmm-header-pad-bottom: clamp(8px, 0.62cqi, 10px);\n    --dmm-bottom-pad-y: clamp(10px, 0.75cqi, 12px);\n    --dmm-loading-pad: clamp(18px, 1.35cqi, 24px);\n  }\n}\n\n@container (max-width: 640px) {\n  .dmm-overlay { padding: 16px; }\n}\n\nbody > .dmm-viewport .dmm-overlay {\n  padding: 40px;\n}\n\n@media (max-width: 640px) {\n  body > .dmm-overlay,\n  body > .dmm-viewport .dmm-overlay {\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
